import { Box, Typography, Container, Grid, Paper } from '@mui/material';
import { motion } from 'framer-motion';

const skills = [
  { name: 'Java', level: 90, category: 'Backend' },
  { name: 'Spring framework', level: 85, category: 'Backend' },
  { name: 'Hibernate (ORM)', level: 85, category: 'Backend' },
   { name: 'Rest API', level: 85, category: 'Backend' },
  { name: 'HTML/CSS', level: 85, category: 'Frontend' },
   {name: 'JavaScript', level: 75, category: 'Frontend' },
  { name: 'React', level: 75, category: 'Frontend' },
  { name: 'React-Native', level: 75, category: 'Frontend' },
  { name: 'MySQL', level: 85, category: 'Database' },
  { name: 'MongoDB', level: 85, category: 'Database' },
  { name: 'Git', level: 85, category: 'Tools' },
   { name: 'Postman', level: 85, category: 'Tools' },
  { name: 'Intellij idea', level: 85, category: 'Tools' },
  { name: 'NetBeans', level: 85, category: 'Tools' },
  { name: 'Ecplise', level: 80, category: 'Tools' },
  { name: 'Docker', level: 75, category: 'DevOps' },
  { name: 'AWS', level: 75, category: 'DevOps' },
  { name: 'Jenkins', level: 70, category: 'DevOps' },
];

const categories = [...new Set(skills.map(skill => skill.category))];

const Skills = () => {
  return (
    <Box id="skills" sx={{ py: 8, bgcolor: 'background.paper' }}>
      <Container maxWidth="lg">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
        >
          <Typography variant="h2" component="h2" align="center" sx={{ mb: 6 }}>
            My Skills
          </Typography>
          
          <Typography variant="h5" align="center" sx={{ mb: 6, color: 'text.secondary', maxWidth: '700px', mx: 'auto' }}>
            Here are the technologies and tools I work with on a regular basis.
          </Typography>
           <Box sx={{ width: '100%', mt: 4, mb: 6 }}>
  {/* New Section: Skills Overview */}
  <motion.div
    initial={{ opacity: 0, y: 20 }}
    whileInView={{ opacity: 1, y: 0 }}
    whileHover={{ scale: 1.01, transition: { duration: 0.2 } }}
    viewport={{ once: true }}
    transition={{ duration: 0.5 }}
  >
  <Box sx={{ 
    maxWidth: '800px', 
    mx: 'auto', 
    mb: 6,
    p: { xs: 2, md: 4 },
    borderRadius: 2,
    background: 'linear-gradient(145deg, rgba(0, 188, 212, 0.03) 0%, rgba(0, 188, 212, 0.01) 100%)',
    border: '1px solid rgba(0, 188, 212, 0.15)',
    boxShadow: '0 8px 32px 0 rgba(0, 0, 0, 0.1)',
    backdropFilter: 'blur(4px)',
    WebkitBackdropFilter: 'blur(4px)',
    transition: 'all 0.3s ease-in-out',
    '&:hover': {
      boxShadow: '0 12px 40px 0 rgba(0, 188, 212, 0.15)',
      borderColor: 'rgba(0, 188, 212, 0.25)'
    }
  }}>
    <motion.div
      initial={{ scale: 0.98, opacity: 0 }}
      whileInView={{ scale: 1, opacity: 1 }}
      viewport={{ once: true }}
      transition={{ duration: 0.5, delay: 0.2 }}
    >
      <Typography 
        variant="h4"
        sx={{ 
          fontWeight: 700, 
          mb: 3, 
          color: 'primary.main',
          display: 'flex',
          alignItems: 'center',
          textShadow: '0 0 10px rgba(0, 188, 212, 0.2)',
          '&:after': {
            content: '""',
            flex: 1,
            ml: 2,
            height: '2px',
            background: 'linear-gradient(90deg, rgba(0, 188, 212, 0.3) 0%, rgba(0, 188, 212, 0) 100%)',
            borderRadius: '2px'
          }
        }}
      >
        <motion.span
          animate={{ 
            textShadow: [
              '0 0 5px rgba(0, 188, 212, 0.3)',
              '0 0 10px rgba(0, 188, 212, 0.4)',
              '0 0 5px rgba(0, 188, 212, 0.3)'
            ]
          }}
          transition={{ duration: 3, repeat: Infinity, ease: 'easeInOut' }}
        >
          Skills Overview
        </motion.span>
      </Typography>
    </motion.div>
    
    <Grid container spacing={3}>
      {[
        { title: 'Backend Development', value: 90, color: '#00bcd4' },
        { title: 'Frontend Development', value: 85, color: '#00acc1' },
        { title: 'Database', value: 85, color: '#0097a7' },
        { title: 'DevOps', value: 75, color: '#00838f' }
      ].map((item, index) => (
        <Grid item xs={12} sm={6} key={index}>
          <Box sx={{ mb: 2 }}>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 1 }}>
              <Typography variant="body1" sx={{ fontWeight: 500, fontSize: '0.95rem' }}>
                {item.title}
              </Typography>
              <Typography variant="body2" sx={{ color: 'primary.main', fontWeight: 600 }}>
                {item.value}%
              </Typography>
            </Box>
            <Box sx={{ 
              width: '100%', 
              height: 8, 
              bgcolor: 'rgba(0, 0, 0, 0.05)', 
              borderRadius: 4,
              overflow: 'hidden',
              boxShadow: 'inset 0 1px 3px rgba(0, 0, 0, 0.1)'
            }}>
              <motion.div
                initial={{ width: 0 }}
                whileInView={{ width: `${item.value}%` }}
                viewport={{ once: true }}
                transition={{ 
                  duration: 1, 
                  delay: index * 0.1,
                  hover: { duration: 0.3 }
                }}
                style={{
                  height: '100%',
                  background: `linear-gradient(90deg, ${item.color}, ${item.color}cc)`,
                  borderRadius: 'inherit',
                  boxShadow: `0 0 15px ${item.color}80`
                }}
                whileHover={{
                  background: `linear-gradient(90deg, ${item.color}, ${item.color}ff)`
                }}
              />
            </Box>
          </Box>
        </Grid>
      ))}
    </Grid>
  </Box>
  </motion.div>

  {/* Existing Skills Grid */}
  <Box 
    sx={{ 
      display: 'flex', 
      justifyContent: 'center',
      width: '100%',
      mt: 4
    }}
  >
    {/* ... rest of your existing skills grid code ... */}
  </Box>
</Box>
          <Box 
            sx={{ 
              display: 'flex', 
              justifyContent: 'center',
              width: '100%',
              mt: 4,
              mb: 6
            }}
          >
            <Box 
              sx={{ 
                display: 'grid',
                gridTemplateColumns: {
                  xs: 'repeat(2, 1fr)',
                  sm: 'repeat(3, 1fr)',
                  md: 'repeat(5, 1fr)'
                },
                gap: 3,
                maxWidth: '1200px',
                width: '100%',
                px: 2
              }}
            >
              {categories.map((category) => (
                <Box key={category}>
                  <Typography 
                    variant="subtitle2" 
                    sx={{ 
                      fontWeight: 700, 
                      mb: 2,
                      color: 'primary.main',
                      textTransform: 'uppercase',
                      fontSize: '0.75rem',
                      letterSpacing: '0.5px',
                      textAlign: 'center'
                    }}
                  >
                    {category}
                  </Typography>
                  <Box sx={{ 
                    display: 'flex', 
                    flexDirection: 'column', 
                    gap: 1.5,
                    alignItems: 'center'
                  }}>
                    {skills
                      .filter(skill => skill.category === category)
                      .map((skill, index) => (
                        <Box 
                          key={index}
                          sx={{
                            width: '100%',
                            maxWidth: '200px',
                            p: 1.5,
                            borderRadius: 1.5,
                            bgcolor: 'rgba(0, 188, 212, 0.03)',
                            border: '1px solid rgba(0, 188, 212, 0.1)',
                            transition: 'all 0.2s ease',
                            '&:hover': {
                              bgcolor: 'rgba(0, 188, 212, 0.05)',
                              transform: 'translateY(-2px)',
                              boxShadow: '0 4px 8px rgba(0, 0, 0, 0.05)'
                            }
                          }}
                        >
                          <Typography 
                            variant="body2" 
                            sx={{ 
                              fontWeight: 500, 
                              color: 'text.primary',
                              fontSize: '0.85rem',
                              mb: 1,
                              textAlign: 'center'
                            }}
                          >
                            {skill.name}
                          </Typography>
                          <Box sx={{ 
                            width: '100%', 
                            height: 4, 
                            bgcolor: 'rgba(0, 0, 0, 0.05)', 
                            borderRadius: 2,
                            overflow: 'hidden'
                          }}>
                            <motion.div
                              initial={{ width: 0 }}
                              whileInView={{ width: `${skill.level}%` }}
                              viewport={{ once: true }}
                              transition={{ duration: 1, delay: index * 0.05 }}
                              style={{
                                height: '100%',
                                background: 'linear-gradient(45deg, #00bcd4, #00acc1)',
                                borderRadius: 'inherit',
                              }}
                            />
                          </Box>
                          <Typography 
                            variant="caption" 
                            sx={{ 
                              display: 'block',
                              textAlign: 'center',
                              mt: 0.5,
                              color: 'primary.main',
                              fontWeight: 600,
                              fontSize: '0.7rem'
                            }}
                          >
                            {skill.level}%
                          </Typography>
                        </Box>
                      ))}
                  </Box>
                </Box>
              ))}
            </Box>
          </Box>
        </motion.div>
      </Container>
    </Box>
  );
};

export default Skills;